export default __webpack_public_path__ + "images/a49ea627947db30db588093fc688cd67-cc-mini-back@2x.png";